import { Component, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { DataService } from '../../services/data.service';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { CardModule } from 'primeng/card';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, MenuModule, CardModule],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss',
})
export class NavbarComponent {
  data = inject(DataService);
  auth = inject(AuthService);
  router = inject(Router);
  profileMenuWidth = 180;

  get links() {
    const baseLinks = [
      { path: '/dashboard', label: 'Home' },
      { path: '/claim-intake', label: 'Claim Intake' },
      { path: '/edge-matters', label: 'Edge Matters' },
      { path: '/requests', label: 'Requests' },
      { path: '/activity', label: 'Activity' },
      { path: '/matter-notes', label: 'Matter Notes' },
      { path: '/edge-files', label: 'Edge Files' },
      { path: '/resources', label: 'Resources' },
    ];

    // Only show Admin link for admin users
    if (this.auth.getUser()?.role === 'admin') {
      baseLinks.push({ path: '/admin', label: 'Admin' });
    }

    return baseLinks;
  }

  profileItems = [
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => {
        this.logout();
      },
    },
  ];

  openProfileMenu(event: Event, menu: { toggle: (ev: Event) => void }) {
    const trigger = event.currentTarget as HTMLElement | null;
    if (trigger) {
      this.profileMenuWidth = Math.ceil(trigger.getBoundingClientRect().width);
    }
    menu.toggle(event);
  }

  logout() {
    this.auth.clearUserData();
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
